import CreateGift from '@/services/gifting/CreateGift';
import FetchPrices from '@/services/gifting/FetchPrices';
import SendIncompleteGiftingData from '@/services/gifting/SendIncompleteGiftingData';
import FetchGiftDeliveryDates from '@/services/gifting/FetchGiftDeliveryDates';

export default class GiftingService {
    createGift(payload) {
        return (new CreateGift()).handle(payload);
    }

    fetchPrices() {
        return (new FetchPrices()).handle();
    }

    async sendIncompleteGiftingData(giftingData, giftingId, userId) {
        return await (new SendIncompleteGiftingData()).handle(giftingData, giftingId, userId);
    }

    fetchGiftDeliveryDates() {
        return (new FetchGiftDeliveryDates()).handle();
    }
}
